// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".case-referral-history .referral-history-table{padding-top:15px}", ""]);
// Exports
module.exports = exports;
